document.addEventListener('DOMContentLoaded', function () {
  if (typeof Lenis === 'undefined') return;

  // 1. Initialize Lenis Smooth Scroll
  const lenis = new Lenis({
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    orientation: 'vertical',
    gestureOrientation: 'vertical',
    smoothWheel: true,
    wheelMultiplier: 1,
    touchMultiplier: 2,
    infinite: false,
  });

  window.lenis = lenis;

  // 2. Synchronize Lenis with GSAP ScrollTrigger
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);

    // Update ScrollTrigger every time Lenis scrolls
    lenis.on('scroll', ScrollTrigger.update);

    // Drive Lenis through GSAP's ticker for zero stutter
    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);

    // 3. Staggered reveal for Product Grids
    const productGrids = document.querySelectorAll('.product-grid, .grid--peek');
    productGrids.forEach((grid) => {
      const items = grid.querySelectorAll('.grid__item');
      if (items.length > 0) {
        items.forEach((item) => item.classList.add('gsap-reveal-item'));

        gsap.to(items, {
          scrollTrigger: {
            trigger: grid,
            start: 'top 85%',
            toggleActions: 'play none none none',
          },
          opacity: 1,
          y: 0,
          duration: 0.9,
          stagger: 0.12,
          ease: 'power3.out',
        });
      }
    });

    // 4. Reveal Section Titles & Banners
    const headings = document.querySelectorAll('.title-wrapper-with-link, .banner__content, .rich-text');
    headings.forEach((heading) => {
      heading.classList.add('gsap-reveal-item');
      gsap.to(heading, {
        scrollTrigger: {
          trigger: heading,
          start: 'top 85%',
          toggleActions: 'play none none none',
        },
        opacity: 1,
        y: 0,
        duration: 0.8,
        ease: 'power2.out',
      });
    });
  } else {
    // Fallback animation loop if GSAP isn't loaded
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
  }
});
